import { supabase } from '../../lib/supabase'

export const previewRuntimeProvider = {
  async load(tenantId: string, roleId: string) {
    const [schema, pointers, modules, policies, visibility] = await Promise.all([
      supabase
        .from('configuration_schema_versions')
        .select('schema_version,allowed_keys,protected_keys,status')
        .eq('schema_version', 1)
        .eq('status', 'active')
        .maybeSingle(),
      supabase
        .from('active_configuration_versions')
        .select('scope_type,scope_key,configuration_version_id')
        .eq('tenant_id', tenantId),
      supabase
        .from('workspace_modules')
        .select('module_id,state')
        .eq('tenant_id', tenantId),
      supabase
        .from('permission_policy_rules')
        .select('role_id,capability_id,object_type,action,decision,module_id,policy_version,is_active')
        .eq('role_id', roleId)
        .eq('is_active', true),
      supabase
        .from('field_visibility_rules')
        .select('object_type,field_key,visibility_class,role_id,readable,policy_version')
        .eq('role_id', roleId)
        .eq('readable', true),
    ])

    for (const result of [schema, pointers, modules, policies, visibility]) {
      if (result.error) return { data: null, error: result.error }
    }

    const pointerRows = pointers.data ?? []
    const versionIds = pointerRows.map((row) => row.configuration_version_id)
    const versions = versionIds.length
      ? await supabase
          .from('configuration_versions')
          .select('id,scope_type,scope_key,schema_version,payload,created_at')
          .eq('tenant_id', tenantId)
          .in('id', versionIds)
      : { data: [], error: null }

    if (versions.error) return { data: null, error: versions.error }

    return {
      data: {
        schema: schema.data,
        pointers: pointerRows,
        versions: versions.data ?? [],
        modules: modules.data ?? [],
        policies: policies.data ?? [],
        visibility: visibility.data ?? [],
      },
      error: null,
    }
  },
}
